import { getStatePure, modifyState } from '~src/state';

export const removePageIndex = async (index) => {
  const pages = getStatePure('pages');
  // Create a new array without the element at the specified index
  const newPages = pages.filter((_, pageIndex) => pageIndex !== index);
  await modifyState('pages', newPages);
};
